// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2Ow42","footer":"ChangeClinic_footer__s1mtQ"};